import styled from "styled-components";
export const LocationWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
